import { borderColor, borderRadius, borderStyle, borderWidth } from "polished"
import { IconAtom } from "../atoms/iconAtom"
import { TextAreaForm } from "../atoms/input"
import { StandardComp } from "../atoms/standardComp"
import { TextAtom } from "../atoms/TextAtom"
import { TitleAtom } from "../atoms/titleAtom"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { StandardButton } from "../atoms/buttons"
import { useContext, useEffect, useState } from "react"
import { PageContext } from "../App"
import { getAPI } from "../api/api"
import { set } from "date-fns"

export const LinkedinComp = () => {
    const {id_lead} = useContext(PageContext).sidebar
    const [status, setStatus] = useState(false)
    const loadLinkedinData = async () => {

        //fetch linkedin data
        const query = `api/linkedin/status?id_lead=${id_lead}`
        const status = await getAPI(query)
        if(status.data.status === 3){
            setStatus(true)
        }
    }   

    useEffect(() => {
        loadLinkedinData()
    },[])
    return (
        status && 
        <StandardComp style={{gap:"1rem", display:"flex", flexDirection:"column", margin:0}}>
            <HeaderLinkedinAI />
            <LastMessages messages={[{title:"Jo heb je me wel gehoord?"}]} />
            <Recommendations recommendations={[{"message_goal":"Haakje zoeken", "message":"Jo ik woon ook in eindhoven"},{"message_goal":"Haakje zoeken", "message":"Jo ik woon ook in eindhoven"}]} />
            <Message lead={{name:"laurens"}} />
        </StandardComp>
    )
}

const HeaderLinkedinAI = () => {
    return (
        <HorizontalLayout style={{gap:"0.5rem"}}>
            <IconAtom
                style={{display:'flex'}}
                iconSize={24}
                color={"var(--grey-700)"}
                icon2={"linkedin"}
            />
          <TextAtom style={{fontSize:"1rem", fontWeight:"bold", color:"var(--grey-700)"}}  title={"AI linkedin berichten"} />

            
        </HorizontalLayout>
    )
}

const LastMessages = ({messages}) => {
    return (
        <VerticalLayout style={{gap:"0.4rem"}}>
   <TextAtom style={{fontSize:"0.8rem", fontWeight:"bold", color:"var(--grey-600)"}}  title={"Laatste berichten"} />

        <CommuncationMessages
            messages = {messages}
        />
        </VerticalLayout>
    )
}


const CommuncationMessages = ({messages}) => {
    return(
        <VerticalLayout>
            {messages.map((message,index)=> {
                return(
                    <CommunicationMessage message={message}/>
                )
            })}
        </VerticalLayout>
    )
}

const CommunicationMessage = ({message}) => {
    return(
        
        <StandardComp style={{padding:"0.75rem"}}>
            <TextAtom

                title={message.title}
            />
        </StandardComp>
    )
}
const Message = ({lead}) => {
    return (
        <VerticalLayout style={{gap:0}}>
            <MessageHeader
                lead={lead}
             />
            <MessageField />
            <SendField />
        </VerticalLayout>
    )
}


const MessageHeader = ({ lead }) => {
    return (
      <HorizontalLayout style={{width:"unset", backgroundColor:"var(--grey-100)", padding:"0.5rem",paddingTop:"0.75rem", paddingBottom:"0.75rem",gap:"0.5rem", marginBottom:"-0.2rem", borderTopLeftRadius:"0.5rem", borderTopRightRadius:"0.5rem", borderColor:"var(--grey-300)", borderStyle:"solid", borderWidth:"1px"}}>
        <div className={"bullet-point"} style={{backgroundColor:"var(--primary-600)"}}></div>
        <TextAtom
            style={{fontSize:"0.8rem"}}
            title={`Vertsuur hier direct een bericht naar ${lead.name}`}
        />
      </HorizontalLayout>
    );
};

const MessageField = () => {
    return (
       <TextAreaForm   
        placeholder={"Druk op een van de aanbeveling om hier direct in toe voegen"}
        style={{marginBottom:0}}
        textAreaStyle={{borderRadius:0}}

       />
    );
};

const SendField = () => {
    return (
  <HorizontalLayout style={{width:"unset", padding:"0.5rem", gap:"0.5rem", marginBottom:"-0.2rem", borderBottomLeftRadius:"0.5rem", borderBottomRightRadius:"0.5rem", borderColor:"var(--grey-300)", borderStyle:"solid", borderWidth:"1px",borderTopWidth:"0", marginTop:"-0.4rem"}}>
        <StandardButton
            title={"Verstuur bericht"}
            style={{marginLeft:"auto", borderRadius:11000}}
            className={"send-button"}
        />
      </HorizontalLayout>
    );
};

const Recommendations = ({recommendations}) => {
    return (
        <VerticalLayout style={{gap:"0.4rem"}}>
            <TextAtom style={{fontSize:"0.8rem", fontWeight:"bold", color:"var(--grey-600)"}}  title={"Aanbevelingen"} />
            <HorizontalLayout>
            {recommendations.map((recommendation, index) => {
                return(
                    <Recommendation data={recommendation}/>
                )
            })}
            </HorizontalLayout>
        </VerticalLayout>
    )
}

const Recommendation = ({data}) => {
    return(
        <StandardComp style={{padding:"0.75rem"}}>
            <HorizontalLayout style={{gap:"0.5rem", alignItems:"center"}}>
                <IconAtom color={"var(--primary-600)"} style={{display:"flex"}} icon2={"Comment"}/>
                <TextAtom style={{fontWeight:"bold", fontSize:"0.8rem"}} title={data.message_goal}/>
            </HorizontalLayout>
            <TextAtom title={data.message}/>
        </StandardComp>
    )
}